import React from 'react';
import moment from 'moment';

export default function (props) {
    const row = props.data
    return (
        <div>
            {moment(row.deliveryDate).format("YYYY-MM-DD")} <br/>
            Jam {moment(row._original.deliveryTime,"HH:mm:ss").format("HH:mm")}
        </div>
    );
}